module.exports = __webpack_public_path__ + "static/media/calories.0e378724.png";